import { useEffect } from 'react';

interface UseGlobalKeyboardShortcutOptions {
  enabled?: boolean;
  key: string;
  metaOrCtrlKey?: boolean;
  onKeyDown: (event: KeyboardEvent) => void;
}

export const useGlobalKeyboardShortcut = ({
  enabled = true,
  key,
  metaOrCtrlKey = false,
  onKeyDown,
}: UseGlobalKeyboardShortcutOptions) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      const keyMatches = event.key.toLowerCase() === key.toLowerCase();
      const modifierMatches = !metaOrCtrlKey || event.metaKey || event.ctrlKey;

      if (keyMatches && modifierMatches) {
        onKeyDown(event);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [enabled, key, metaOrCtrlKey, onKeyDown]);
};
